module.exports = __webpack_public_path__ + "img/loghi_0010_csv_padova.06458868.png";